module.exports = __webpack_public_path__ + "img/ANTENNA FLOWER PURPLE.e3fd6fc.svg";